import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { ICarAnswers } from 'models/requests/CarDetailRequests';
import { IInspectionBody } from 'models/requests/InspectionRequests';
import {
  ICarDetail,
  ICarDetailsInfoResponse,
  IProvincesResponse,
} from 'models/response/CarDetailResponse';

import { BaseQueryType } from '../../api';

export const fetchQuestions = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.query<ICarDetail[], void>({
    query: () => `v1/inspection_cardetailitems/`,
  });

export const fetchCarDetailInfo = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.query<ICarDetailsInfoResponse, void>({
    query: () => 'v1/cardetail_info/',
  });

export const submitAnswers = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.mutation<void, IInspectionBody<ICarAnswers>>({
    query: ({ slug, body }) => ({
      url: `v1/inspection/${slug}/car_detail/`,
      body: body,
      method: 'PATCH',
    }),
  });
export const fetchProvinces = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.query<IProvincesResponse, void>({
    query: () => `v1/place/province/`,
  });
export const fetchCities = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.query<IProvincesResponse, { provinceId: number }>({
    query: ({ provinceId }) => `v1/place/city/${provinceId}/`,
  });
